import React from "react";
import { SovosDialog, SovosButton, SovosDialogActions, SovosDialogContent, SovosDialogTitle } from 'mosaic-react';

const AlertDialog = (props) => {
    const { data, cancel, i18n, confirm } = props;
    const { title, text, cancelEvent = true } = data;

    return (
        <SovosDialog open={true}>
            <SovosDialogTitle>{title}</SovosDialogTitle>
            <SovosDialogContent>{text}</SovosDialogContent>
            <SovosDialogActions>
                <SovosButton onClick={() => {
                                cancelEvent ? cancel && cancel() : confirm && confirm()
                            }}>
                        {i18n`Confirm`}
                </SovosButton>
            </SovosDialogActions>
       </SovosDialog>
    );
};

export default AlertDialog;
